export default "/_next/static/images/Luxury-87c3036388605f49ba579a9dd8c384a2.png";